import type { ChatSubagentCard } from "../ui-types.ts";
import { applySpawnResultToCard } from "./subagents.ts";

type SpawnResult =
  | { ok: true; childSessionKey: string; runId: string; model?: string; warning?: string }
  | { ok: false; error: string; cap?: boolean };

export function applySpawnAndNotify(
  cards: ChatSubagentCard[],
  cardId: string,
  result: SpawnResult,
  onSpawned?: (card: ChatSubagentCard) => void,
): ChatSubagentCard[] {
  const next = applySpawnResultToCard(cards, cardId, result);
  if (result.ok && onSpawned) {
    const card = next.find((c) => c.id === cardId);
    if (card?.childSessionKey) {
      onSpawned(card);
    }
  }
  return next;
}
